import { render } from "./ExtranetMerchant.vue?vue&type=template&id=785c889c&scoped=true"
import script from "./ExtranetMerchant.vue?vue&type=script&lang=js"
export * from "./ExtranetMerchant.vue?vue&type=script&lang=js"

import "./ExtranetMerchant.vue?vue&type=style&index=0&id=785c889c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785c889c"]])

export default __exports__